<div class="body">
  <div class="dialogTitleContainer">
    <span class="dialogTitle">Details</span>
    <span class="dialogTitle" style="cursor: pointer;" (click)="close()">X</span>
  </div>
  <div class="dialogDataContainer flex_column">
    <div class="dialogData flex_column" *ngFor="let item of campusTypeData">
      <div class="dialogDataTitleContainer">
        <span class="dialogDataTitle">{{item.los}}</span>
        <span class="dialogDataTitle">{{item.total}}</span>
      </div>
      <div class="dialogDataContent">
        <span class="dialogContent">Started : {{item.started}}</span>
        <span class="dialogContent">Pending : {{item.pending}}</span>
        <span class="dialogContent">Completed : {{item.percentage}}%</span>
      </div>
    </div>

  </div>
  <div>
    <div >
      <div id="pieChart"></div>
      <div style="display: flex; flex-direction: row;flex-wrap: wrap;justify-content: center;">
        <span style="display: flex; flex-direction: row; gap: 5px;">
          <div style="background-color: #026FD4; border:1px solid #026FD4" class="dot"></div>
          <span style="font-size: 11px;">Ds And Res</span>
        </span>
        <span style="display: flex; flex-direction: row;gap: 5px;">
          <div style="background-color: #0CA766; border:1px solid #0CA766" class="dot"></div>
          <span style="font-size: 11px;">Day scholar</span>
        </span>
        <span style="display: flex; flex-direction: row;gap: 5px;">
          <div style="background-color: #FB9D05; border:1px solid #FB9D05" class="dot"></div>
          <span style="font-size: 11px;">Residential</span>
        </span>
      </div>

    </div>
  </div>
</div>

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>